import React from 'react';
import { CSVLink } from 'react-csv';
import { Button, Icon, Popup } from 'semantic-ui-react';


// eslint-disable-next-line import/prefer-default-export
export const ExportReactCSV = ({
    csvData, headers, fileName, floated, icon, color, circular, fluid, compact, disabled
}) => (
    <CSVLink data={csvData} filename={fileName} headers={headers} target="_blank" >
        {icon ? <Popup
            trigger={<Button icon basic floated={floated} color={color} circular={circular} fluid={fluid} disabled={disabled}>
                <Icon name="download" />
            </Button>
            }
            content="Preuzmi spisak u Excel-u"
            hideOnScroll
            position="top center"
        />

            : <Popup
                trigger={<Button animated="vertical" color={color} basic floated={floated} fluid={fluid} compact={compact} disabled={disabled}>
                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                    <Button.Content visible>
                        Excel
                    </Button.Content>
                </Button>}
                content="Preuzmi spisak u Excel-u"
                hideOnScroll
                position="top center"
            />}
    </CSVLink>

);



// WEBPACK FOOTER //
// ./src/views/util/ExportCSV.js